import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: {
        background: '#18203a', padding: '5px 5px 5px 5px', borderRadius: 4
    },
    wrap: {
        paddingLeft: 12, minHeight: '100%'
    },
    label: {
        fontWeight: 700, userSelect: 'none'
    },
    children: {
        marginTop: 8
    }
}))

export {
    useStyles
}